export const AIR_QUALITY_INDEX = [
	{1: 'good'},
	{2: 'fair'},
	{3: 'moderate'},
	{4: 'poor'},
	{5: 'very poor'},
]